import { environment } from 'src/environments/environment';
import { CountryCode } from '../models/country.enum';

export const CONVERSION_TIMEOUT_MS = 10 /** min */ * 60 * 1000;

// TODO allow all countries for prod and dev once we have multi currency support on peach
export const COUNTRY_OPTIONS: CountryOption[] = [
  {
    image: '/assets/flags/za.svg',
    code: CountryCode.ZA,
    name: 'South Africa',
  },
  {
    image: '/assets/flags/us.svg',
    code: CountryCode.US,
    name: 'United States',
  },
  {
    image: '/assets/flags/gb.svg',
    code: CountryCode.UK,
    name: 'United Kingdom',
  },
  {
    image: '/assets/flags/xx.svg',
    code: CountryCode.Other,
    name: 'Other',
  },
];

export interface CountryOption {
  image: string;
  code: CountryCode;
  name: string;
}
